import React from 'react';
import UserList from '../Common/UserList';
import { Helmet } from "react-helmet";
import Directory from '../../Images/Directory.png';

const AppMetaHeader = {
    title: "#mfimovers - Directory",
    description: "MFI (Movers Federation of India) is India's Largest forum of Pre-own and managed relocation companies",
    keywords: "packer and movers ,logistics ,packers ,movers, MFI ,mfi packers ,mfi movers ,movers in india, packers in india",
    site_name: "MFI Packers and Movers",
    url: "app.mfind.net/",
    type: "business.business"
}

const PartnerDirectory = () => {

    return (
        <div style={{
            height: "95vh",
            backgroundSize: "cover", backgroundPosition: "center", backgroundRepeat: "no-repeat",
            backgroundImage: "url('" + Directory + "')"
        }}>
            <Helmet>
                <meta property="title" content={AppMetaHeader.title} />
                <meta property="og:title" content={AppMetaHeader.title} />
                <meta name="description" content={AppMetaHeader.description} />
                <meta name="og:description" content={AppMetaHeader.description} />
                <meta name="keyword" content={AppMetaHeader.keywords} />
                <meta property="og:site_name" content={AppMetaHeader.title} />
                <meta name="twitter:card" content="summary_large_image" />
            </Helmet>
            <div className="user-list-main container-fluid sidemenu-show" style={{
                border: "1px solid #ccc", borderRadius: "10px",
                marginTop: "1rem", background: "rgba(255,255,255,0.7)"
            }}>
                <div className="row no-gutters pb-1" style={{ borderBottom: "1px solid #ccc" }}>
                    <div className="col-md-12 col-sm-12">
                        <h4 className="align-center" style={{ fontWeight: "500" }}>#mfimovers - Directory</h4>
                    </div>
                </div>
                <UserList fullAllow={1}></UserList>
            </div>
        </div>
    );
};

export default PartnerDirectory;